import React from "react";
import { Button } from "@components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CarouselActionButtonProps {
  direction: "left" | "right";
  onClick: () => void;
  disabled?: boolean;
  props?: React.ComponentProps<typeof Button>;
}

export function CarouselActionButton({
  direction,
  onClick,
  disabled = false,
  props,
}: Readonly<CarouselActionButtonProps>) {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      size="sm"
      className="size-10 rounded-full bg-transparent"
      disabled={disabled}
      aria-label={`Scroll ${direction}`}
      {...props}
    >
      {direction === "left" ? <ChevronLeft size={48} /> : <ChevronRight />}
    </Button>
  );
}
